/* eslint-disable max-lines-per-function */
import React from "react";

import { Link } from "@reach/router";
import { useFormikContext } from "formik";
import { Grid, Typography, Link as MuiLink } from "@material-ui/core";
import classNames from "classnames";
import { CheckboxWithErrorLabel } from "components/haven-design/form/checkbox";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { getReturnToUrl } from "utils/login";
import { LoginFormValues } from "../type";
import { isEmailIdentifier } from "../utils";
import styles from "./Login.module.css";
import { loginStyles } from "./styles";

const LoginForm: React.FC<{toSignUp: () => void;}> = ({ toSignUp }) => {
  const { values: { identifier, showPassword }, isSubmitting } =
    useFormikContext<LoginFormValues>();

  const isEmail = isEmailIdentifier(identifier);

  const returnToUrl = getReturnToUrl();
  const retunToCurrent = returnToUrl ? `?return-to=${returnToUrl}` : "";
  return (
    <div>
      <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
        <Grid item>
          <InputWithErrorLabel
            label="Email or Cell Phone"
            name="identifier"
            id="identifier"
            type="text"
            style={loginStyles.loginInput}
            autoFocus
          />
        </Grid>

        <Grid item xs={12} className={classNames({ [styles.invisibleButFillable]: !isEmail })}>
          <InputWithErrorLabel
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete={showPassword ? "off" : "current-password"}
            id="password"
            style={loginStyles.loginInput}
          />

          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Link
              to={`/reset-password${retunToCurrent}`}
              state={{ email: identifier }}>
              <Typography variant="body1" style={loginStyles.forgotPassword}>
                Forgot password?
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Grid>

      {isEmail && (
        <Grid container direction="column" alignItems="flex-start" justifyContent="flex-start" item>
          <CheckboxWithErrorLabel
            label="Show password"
            name="showPassword"
            id="showPassword"
            style={loginStyles.showPassword}
          />
          <CheckboxWithErrorLabel
            name="remember"
            id="remember"
            label="Remember my Email"
            style={loginStyles.checkbox}
          />
        </Grid>
      )}

      <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
        <Grid item>
          <Button
            id="login-btn"
            type="submit"
            color="primary"
            size="L"
            fullWidth
            className={styles.loginButton}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Loading..." : "Log In"}
          </Button>
        </Grid>
        <div>
          <Typography variant="body2" display="inline" style={{ verticalAlign: "middle" }}>
            Don&apos;t have an account?&nbsp;
          </Typography>
          <MuiLink component="button" variant="body2" display="inline" onClick={toSignUp}>Sign Up</MuiLink>
        </div>
      </Grid>
    </div>
  );
};

export default LoginForm;
